import { Builder } from "@builder.io/react";
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from "../BuilderComponentsName";
import { backgroundGradientOptions, iconColorOptions, textColorOptionsLimited } from "../utils/builderColorOptions";
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from "../utils/builderSharedInputs";
import { S17ToggleTabsSection } from "../components/interactive-sections/S17ToggleTabsSection";

Builder.registerComponent(S17ToggleTabsSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S17ToggleTabs,
    friendlyName: 'S17 Toggle Tabs',
    inputs: [
        {
            name: 'headlineText',
            type: 'string',
            friendlyName: 'Headline',
            required: true,
            defaultValue: 'Experience the Future of Laser Hair Removal',
            helperText: 'The main heading displayed at the top of the section'
        },
        {
            name: 'headlineColor',
            type: 'string',
            friendlyName: 'Headline Color',
            enum: textColorOptionsLimited,
            defaultValue: 'Blue',
            helperText: 'Select a color for the headline text'
        },
        {
            name: 'text1',
            type: 'string',
            friendlyName: 'Text 1',
            defaultValue: 'Our advanced laser technology provides precise, long-lasting results with minimal discomfort. Discover how our innovative approach is revolutionizing hair removal treatments.',
            helperText: 'Supporting first text content below the headline. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}'
        },
        {
            name: 'text2',
            type: 'string',
            friendlyName: 'Text 2',
            defaultValue: 'Are you a good candidate for laser hair removal? Answer 5 quick questions to help determine if you qualify.',
            helperText: 'Supporting second text content below the headline. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}'
        },
        {
            name: 'textColor',
            type: 'string',
            friendlyName: 'Text Color',
            enum: textColorOptionsLimited,
            defaultValue: 'Navy',
            helperText: 'Select a color for both Text 1 and  Text 2'
        },
        {
            name: "tabGroupProps",
            type: "list",
            helperText: "List of tabs to display",
            friendlyName: "Tabs",
            required: true,
            onChange: (options) => {
                // Check if the list has more than 3 items
                if (options.get('tabGroupProps').length > 3) {
                  options.set('tabGroupProps', options.get('tabGroupProps').slice(0, 3))
                  alert('maximum items is 3, delete items to continue')
                }
                // check if the list has less than 3 items
                if (options.get('tabGroupProps').length < 3) {
                    alert('minimum items is 3, add items to continue')
                }
            },
            subFields: [
                {
                    name: "icon",
                    type: 'file',
                    allowedFileTypes: ['svg'],
                    friendlyName: "Icon",
                    helperText: "Icon image",
                    required: true,
                },
                {
                    name: "label",
                    type: "string",
                    friendlyName: "Label",
                    required: true,
                },
                {
                    name: "content",
                    type: "string",
                    friendlyName: "Paragraph", 
                    helperText: "Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}",
                    required: true,
                },

            ],
            defaultValue: [
                {id: 1, icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fd292ec0fb0aa4fe8939327ac90a1b520', label: "Redness", content: "Underarm laser hair removal leaves you with smooth skin free of bumps, razor burn, prickly hair, and all that other unfun stuff."},
                {id: 2, icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F9c4befdd4f364233b4b48fefaee6d35a', label: "Burning", content: "Facial laser hair removal leaves your skin soft and smooth, making things like makeup application easier than ever."},
                {id: 3, icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F59e37ed50eb243ac9367f7eebf616dfc', label: "Blisters", content: "Laser hair removal reduces hair density, regrowth, and pigmentation from shaving which can cause dark shadows on delicate underarm skin."},
            ],
            
            
        },
        {
            name: "iconColor",
            type: "string",
            defaultValue: "Navy",
            friendlyName: "Icon Color",
            helperText: "Color change will apply to SVG icons only",
            enum: iconColorOptions,
            required: false,
        },
        {
            name: 'tabLabelColor',
            type: "string",
            enum: textColorOptionsLimited,
            friendlyName: "Tab Label Color",
            defaultValue: "Navy",

        },
        {
            name: 'tabParagraphColor',
            type: "string",
            enum: textColorOptionsLimited,
            friendlyName: "Tab Paragraph Color",
            defaultValue: "Navy",
        },
        ...getBackgroundColorInput({
            defaultValue: 'None',
        }),
        ...getBackgroundGradientInput({
            defaultValue: 'BlueTop',
            backgroundGradientList: backgroundGradientOptions
        }),
        ...getPaddingInputs({
            desktopTop: "small",
            desktopBottom: 'small',
            mobileTop: 'small',
            mobileBottom: 'small',
        })
    ],
});

